import { render, staticRenderFns } from "./DeliveryPointBoxesCard.vue?vue&type=template&id=0cc557ce"
import script from "./DeliveryPointBoxesCard.vue?vue&type=script&lang=js"
export * from "./DeliveryPointBoxesCard.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPointBoxesCard.vue?vue&type=style&index=0&id=0cc557ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports